module.exports = __webpack_public_path__ + "bd0e0d05952b8da1043e469b59f3aea5.pdf";